<template>
  <div class='h100vh-100'>
    <ToolBarForGnbPmDataQueryRightList ref="toolBarForGnbPmDataQueryRightList"></ToolBarForGnbPmDataQueryRightList>
    <ContentForGnbPmDataQueryRightList ref="contentForGnbPmDataQueryRightList" @gnbPmDataQueryListPageClick="gnbPmDataQueryListPageClick" :dataLength="dataLength"></ContentForGnbPmDataQueryRightList>
    <CustomDialog ref='gnbPmDataSearchDialog' :element='gnbPmDataSearchDialog.element' :styles='gnbPmDataSearchDialog.style'>
      <template v-slot:dialog-content>
        <GnbPmDataSearchDialog ref='gnbPmDataSearch'></GnbPmDataSearchDialog>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
  import ToolBarForGnbPmDataQueryRightList from "./ToolBarForGnbPmDataQueryRightList";
  import ContentForGnbPmDataQueryRightList from "./ContentForGnbPmDataQueryRightList";
  import {EventBus} from "../../../../../plugins/eventBus";
  import CustomDialog from "../../../../common/CustomDialog";
  import GnbPmDataSearchDialog from "./dialog/GnbPmDataSearchDialog";
  import DateUtil from "../../../util/DateUtil";

  export default {
    name: 'GnbPmDataQueryRightList',
    props: [
      'treeClickInfo'
    ],
    components: {
      ToolBarForGnbPmDataQueryRightList,
      ContentForGnbPmDataQueryRightList,
      CustomDialog,
      GnbPmDataSearchDialog
    },
    data() {
      return {
        gnbPmDataSearchDialog: {
          style: {
            width: '800px',
            height: '600px',
            visible: false,
            model: true
          },
          element: {
            title: this.$t('Pm.gnbPmDataQuery'),
            target: this.$refs.contentForGnbPmDataQueryRightList,
            refName: 'gnbPmDataSearchElement',
            buttonGroup: [
              { click: this.closeGnbPmDataSearchDialog, buttonModel: { content: this.$t('Common.cancel') } },
              { click: this.gnbPmDataSearchCommit, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
            ],
            isClose: true
          }
        },
        dataLength: 0,
        startTime: '',
        endTime: '',
        checkSystemNodeIdList: [],
        checkCustomNodeIdList: [],
        neId: '',
        spaceCode: '',
        paramTypeCode: ''
      };
    },
    methods: {

      gnbPmDataQueryListPageClick(currentPage){
        this.$axios.post('/lte/ems/pm/gnb/query/getGnbPmData.html', {
          startTime: this.startTime,
          endTime: this.endTime,
          checkSystemNodeIdList: this.checkSystemNodeIdList,
          checkCustomNodeIdList: this.checkCustomNodeIdList,
          neId: this.neId,
          spaceCode: this.spaceCode,
          paramTypeCode: this.paramTypeCode,
          page: {
            pageNo: currentPage,
            pageSize: 18
          }
        }).then((response) => {
          const result = response.data.resultVal.result;
          if (result.length != 0) {
            this.$refs.contentForGnbPmDataQueryRightList.page.totalRecordsCount = response.data.resultVal.totalCount;
            this.$refs.contentForGnbPmDataQueryRightList.page.currentPage = response.data.resultVal.pageNo;
          } else {
            this.$refs.contentForGnbPmDataQueryRightList.page.totalRecordsCount = 0;
            this.$refs.contentForGnbPmDataQueryRightList.page.currentPage = 1;
          }
          this.$refs.contentForGnbPmDataQueryRightList.dataSourceOfGnbPmDataQuery = result;
          this.$loading.hideLoadding();
        });
        this.$refs.gnbPmDataSearchDialog.close();
      },

      closeGnbPmDataSearchDialog(){
        this.$refs.gnbPmDataSearchDialog.close();
      },

      gnbPmDataSearchCommit(){

        const ruleDatas = this.$refs.gnbPmDataSearch.validateOfGnbPmSearchDialog();
        if (!ruleDatas) {
          return;
        }
        this.checkSystemNodeIdList = this.$refs.gnbPmDataSearch.checkSystemNodeIdList;
        this.checkCustomNodeIdList = this.$refs.gnbPmDataSearch.checkCustomNodeIdList;
        if (this.checkSystemNodeIdList.length <= 0 && this.checkCustomNodeIdList.length <= 0) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.pleaseSelectCounter') });
          return;
        }
        this.startTime = DateUtil.getTr069DateString(this.$refs.gnbPmDataSearch.startTime);
        this.endTime = DateUtil.getTr069DateString(this.$refs.gnbPmDataSearch.endTime);


        let paramList = this.treeClickInfo.id.split('_');
        this.spaceCode  = paramList[0];
        this.paramTypeCode = paramList[1];
        this.neId = paramList[2];

        console.log('paramList', paramList);
        console.log('paramTypeCode', this.paramTypeCode);
        console.log('spaceCode', this.spaceCode);
        console.log('neId', this.neId);

        this.$refs.contentForGnbPmDataQueryRightList.getColumnsOfGnbPmDataQuery(this.$refs.gnbPmDataSearch.checkSystemNodeList, this.$refs.gnbPmDataSearch.checkCustomNodeList);
        this.dataLength = this.$refs.gnbPmDataSearch.checkSystemNodeList.length + this.$refs.gnbPmDataSearch.checkCustomNodeList.length;
        this.$refs.contentForGnbPmDataQueryRightList.$refs.gnbPmDataQueryList.refreshColumns();
        this.$loading.showLoadding(this.$t('System.loading'));
        this.$axios.post('/lte/ems/pm/gnb/query/getGnbPmData.html', {
          startTime: this.startTime,
          endTime: this.endTime,
          checkSystemNodeIdList: this.checkSystemNodeIdList,
          checkCustomNodeIdList: this.checkCustomNodeIdList,
          neId: this.neId,
          spaceCode: this.spaceCode,
          paramTypeCode: this.paramTypeCode,
          page: {
            pageNo: 1,
            pageSize: 18
          }
        }).then((response) => {
          const result = response.data.resultVal.result;
          if (result.length != 0) {
            this.$refs.contentForGnbPmDataQueryRightList.page.totalRecordsCount = response.data.resultVal.totalCount;
            this.$refs.contentForGnbPmDataQueryRightList.page.currentPage = 1;
          } else {
            this.$refs.contentForGnbPmDataQueryRightList.page.totalRecordsCount = 0;
            this.$refs.contentForGnbPmDataQueryRightList.page.currentPage = 1;
          }
          this.$refs.contentForGnbPmDataQueryRightList.dataSourceOfGnbPmDataQuery = [];
          this.$refs.contentForGnbPmDataQueryRightList.dataSourceOfGnbPmDataQuery = result;
          this.$loading.hideLoadding();
        });
        this.$refs.gnbPmDataSearchDialog.close();
      },

      methodList(operator) {
        switch (operator) {
          case 'query':
            this.queryData();
            break;
          default:
        }
      },
      queryData(){
        if(this.treeClickInfo.hasChildren){
          EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.pleaseSelectSpaceNode') });
          return;
        }
        this.$refs.gnbPmDataSearch.getGnbPmDataSearchTree(this.treeClickInfo.id);
        this.$refs.gnbPmDataSearch.bindValidateOfGnbPmSearchDialog();
        this.$refs.gnbPmDataSearchDialog.show();
      }
    },
    watch: {
    }
  };
</script>

<style>
</style>
